import { useEffect, useState } from "react";
import useFirebase from "../useFirebase";
import { CallStatus } from "types/auth";
import useUserCalls from "./useUserCalls";

// Incoming-call queue. Reads ONLY the user's own recent calls (via the
// `call-recipients/{uid}` index) instead of streaming the entire `video-calls`
// node app-wide. Signature kept for callers; the authenticated Firebase uid is
// the source of truth.
const useCallQueue = (_userId?: string) => {
  const [calls, setCalls] = useState<any[]>([]);
  const { firebaseUid } = useFirebase();
  const userCalls = useUserCalls();

  useEffect(() => {
    const userId = firebaseUid;
    if (!userId) {
      setCalls([]);
      return;
    }

    const filteredCalls = userCalls.filter(
      (call: any) =>
        (call.status === CallStatus.CALLING || call.status === CallStatus.IN_PROGRESS) &&
        call.recipients?.includes(userId) &&
        // Only include recent calls (within last 5 minutes) so old calls don't
        // block new incoming ones.
        call.initiated && Date.now() - call.initiated < 5 * 60 * 1000
    );

    setCalls(filteredCalls);
  }, [userCalls, firebaseUid]);

  return calls;
};

export default useCallQueue;
